import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {RecaptchaV3Module} from 'ng-recaptcha-2';

import {SignInPageComponent} from '../pages/sign-in/sign-in.component';
import {SignUpPageComponent} from '../pages/sign-up/sign-up.component';
import {RestoringPageComponent} from '../pages/restoring/restoring.component';
import {ResentPasswordPageComponent} from '../pages/resent-password/resent-password.component';
import {NewPasswordPageComponent} from '../pages/new-password/new-password.component';

import {TextBoxComponent} from '../components/ui/text-box/text-box.component';
import {TextButtonComponent} from '../components/ui/text-button/text-button.component';
import {CheckBoxComponent} from '../components/ui/check-box/check-box.component';
import {FocusDirective} from '../components/ui/common/focus.directive';
import {InputLineFormComponent} from '../components/inputs-new/input-line-form/input-line-form.component';
import {InputPasswordComponent} from '../components/inputs-new/input-password/input-password.component';
import {UiButtonComponent} from '../components/ui/ui-button/ui-button.component';
import {IconsaxDirective} from '../directives/iconsax.directive';
import {AutofocusDirective} from '../directives/autofocus.directive';
import {HtmlSanitizerPipe} from '../pipes/html-sanitizer.pipe';

/**
 * The public, unauthenticated half of the app: everything reachable without a token.
 *
 * This module is eager, and is deliberately the ONLY page module in the eager bundle — it is what a
 * marketing-site visitor and Google PageSpeed actually download. Keep it that way: it pulls in its
 * standalone leaf components, directives and pipes directly rather than importing `UIComponentsModule`, `SharedModule` or
 * `WidgetComponentsModule`, which between them declare ~270 components and drag in pdf-viewer,
 * angular-mentions and daterangepicker. Adding one of those module imports here would quietly undo
 * the bundle split.
 */
@NgModule({
    declarations: [
        SignInPageComponent,
        SignUpPageComponent,
        RestoringPageComponent,
        ResentPasswordPageComponent,
        NewPasswordPageComponent
    ],
    imports: [
        CommonModule,
        // FormsModule is load-bearing even though no template uses ngModel: its NgForm directive is
        // what attaches to a bare `<form (ngSubmit)>` (sign-in ×2, restoring), cancels the browser's
        // native submit and emits ngSubmit. Without it, an implicit submit (Enter, or picking an
        // autofill entry) does a native GET that reloads the page with every field — password
        // included — in the query string. auth-pages.module.spec.ts guards this.
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        UIRouterModule,
        RecaptchaV3Module,
        // Standalone leaf UI used by the auth templates.
        TextBoxComponent,
        TextButtonComponent,
        CheckBoxComponent,
        FocusDirective,
        InputLineFormComponent,
        InputPasswordComponent,
        UiButtonComponent,
        IconsaxDirective,
        // Imported individually, never via DirectivesModule (pulls pdfjs) or PipesModule.
        AutofocusDirective,
        HtmlSanitizerPipe
    ],
    exports: [
        SignInPageComponent,
        SignUpPageComponent,
        RestoringPageComponent,
        ResentPasswordPageComponent,
        NewPasswordPageComponent
    ]
})
export class AuthPagesModule {
}
